import {
    LOGIN_SUCCESS,
    LOGOUT_SUCCESS,
    LOGOUT_FAIL,
    GET_QUOTES,
    GET_QUOTE,
    CREATE_QUOTE,
    EDIT_QUOTE,
    SEND_QUOTE,
    RESPOND_TO_QUOTE,
    CONVERT_QUOTE,
    DELETE_QUOTE,
    CLEAR_QUOTE,
} from "../actions/types";

const initialState = {
    quotes: [],
    noQuotesExist: false,
    quote: {},
};

export default function (state = initialState, action) {
    switch (action.type) {
        // ensure no redux values linger between users ----
        case LOGIN_SUCCESS:
        case LOGOUT_SUCCESS:
        case LOGOUT_FAIL:
            return {
                ...initialState,
            };
        // ------------------------------------------------
        case GET_QUOTES:
            return {
                ...state,
                quotes: action.payload,
                noQuotesExist: action.payload.length === 0,
            };
        case GET_QUOTE:
            return {
                ...state,
                quote: action.payload,
            };
        case CREATE_QUOTE:
            return {
                ...state,
                quotes: [...state.quotes, action.payload],
                quote: action.payload,
                noQuotesExist: false,
            };
        case EDIT_QUOTE:
        case SEND_QUOTE:
        case RESPOND_TO_QUOTE:
            return {
                ...state,
                quote: action.payload,
                quotes: state.quotes.map((quote) => (quote.quote_id === action.payload.quote_id ? { ...quote, ...action.payload } : quote)),
            };
        case CONVERT_QUOTE:
            // payload here is the newly-created Contract's own response shape (not a
            // Quote), since QuoteViewSet.convert redirects the caller into the normal Contract
            // screens -- nothing in this slice to update, the component navigates away instead
            return state;
        case DELETE_QUOTE:
            return {
                ...state,
                quote: {},
                quotes: state.quotes.filter((quote) => quote.quote_id !== action.payload),
                noQuotesExist: state.quotes.length <= 1,
            };
        case CLEAR_QUOTE:
            return {
                ...state,
                quote: {},
            };
        default:
            return state;
    }
}
